import Icon, { type IconName } from "./Icon";

export interface StatCardDelta {
  pct: number;
  direction: "up" | "down" | "neutral";
}

export interface StatCardProps {
  iconName: IconName;
  value: string;
  unit: string;
  label: string;
  delta?: StatCardDelta | null;
  onClick?: () => void;
  /** Two-state toggle indicator shown on the right edge when interactive. */
  toggle?: { activeIndex: number; count: number };
}

export default function StatCard({
  iconName,
  value,
  unit,
  label,
  delta,
  onClick,
  toggle,
}: StatCardProps) {
  const interactive = !!onClick;
  const className = "stat-card" + (interactive ? " stat-card--interactive" : "");
  const body = (
    <>
      <div className="stat-card__top">
        <div className="stat-card__icon">
          <Icon name={iconName} />
        </div>
        <div className="stat-card__value">{value}</div>
        {delta != null && (
          <span className={`stat-card__delta stat-card__delta--${delta.direction}`}>
            {delta.direction === "up" ? "↑" : delta.direction === "down" ? "↓" : ""}
            {Math.abs(delta.pct).toFixed(0)}%
          </span>
        )}
      </div>
      <div className="stat-card__meta">
        <span className="stat-card__label">{label}</span>
        {unit && <span className="stat-card__unit">{unit}</span>}
        {toggle && (
          <div className="stat-card__toggle" aria-hidden="true">
            {Array.from({ length: toggle.count }).map((_, i) => (
              <span
                key={i}
                className={
                  "stat-card__dot" +
                  (i === toggle.activeIndex ? " stat-card__dot--active" : "")
                }
              />
            ))}
          </div>
        )}
      </div>
    </>
  );

  if (interactive) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {body}
      </button>
    );
  }
  return <article className={className}>{body}</article>;
}
